import {
	GOALS_APP_READING_MODE_PATH,
	PROJECTS_APP_READING_MODE_PATH,
	READING_MODE_PAGE,
	READING_MODE_PATH,
} from '@townsquare/config/routes';
import { createGlobalRoute } from '@townsquare/router/create-route';

export const readingModeRoute = createGlobalRoute({
	exact: true,
	name: READING_MODE_PAGE,
	path: READING_MODE_PATH,
});

export const goalsAppReadingModeRoute = createGlobalRoute({
	exact: true,
	name: READING_MODE_PAGE,
	path: GOALS_APP_READING_MODE_PATH,
});

export const projectsAppReadingModeRoute = createGlobalRoute({
	exact: true,
	name: READING_MODE_PAGE,
	path: PROJECTS_APP_READING_MODE_PATH,
});
